"use strict";
import { getCurrencySafetyInfo } from "features/dataApi/utils";
import { SearchResultType } from "features/search/SearchResult";
import { tokenAddressOrNativeAddress } from "features/search/utils";
export const searchTokenToTokenSearchResult = (searchToken) => {
  return {
    type: SearchResultType.Token,
    chainId: searchToken.chainId,
    symbol: searchToken.symbol ?? "",
    address: tokenAddressOrNativeAddress(searchToken.address, searchToken.chainId),
    name: searchToken.name ?? null,
    logoUrl: searchToken.project?.logoUrl ?? null,
    safetyInfo: getCurrencySafetyInfo(searchToken.project?.safetyLevel ?? void 0, searchToken.protectionInfo),
    feeData: searchToken.feeData ?? null
  };
};
